import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { Organization, User } from '@paragon/contract-library';
import { UserService } from '@paragon/data-connections';

import { reloadPage } from '../../utilities/reloadPage';

// A lot of things in this components are hacky/wrong/contrary to our preferred style.  But since it's just a dev tool,
//   and will only be used internally and by a few people, I didn't want to spend too much time on polishing.
//
// If you ever want to render this component elsewhere for production use, some refactoring would be nice.

const INPUT_PROPS = { id: 'organization-dev-tool' };
const CONTAINER_STYLE = { marginLeft: '24px', marginRight: '24px', marginTop: 0, marginBottom: '16px' };

export const UserOrganizationDropdown: FunctionComponent<{ user: User }> = (props) => {
  const [organizations, setOrganizations] = useState<'loading' | Organization[]>('loading');

  useEffect(() => {
    UserService.get<Organization[]>('organizations').then(setOrganizations);
  }, []);

  let menuItems;
  if (organizations === 'loading') {
    menuItems = <MenuItem value={props.user.organization}>Loading organizations...</MenuItem>;
  } else {
    menuItems = organizations.map((organization, i) => (
      <MenuItem key={i} value={organization.name}>
        {organization.name}
      </MenuItem>
    ));
  }

  async function onChangeOrganization(newOrganizationName: string) {
    if (!Array.isArray(organizations)) throw new Error('Invalid state.');

    const newOrganization = organizations.find((o) => o.name === newOrganizationName);
    if (!newOrganization) throw new Error('Invalid state.');

    await UserService.patch(`users/${props.user.email}`, {
      data: {
        organization: newOrganization.name,
        locations: newOrganization.locations,
      },
    });

    // Changing the user's organization can affect a lot of things that could be messy to update, like access to
    //   the current project/components and the entire client's theme.  So it's easier to just refresh the page.
    reloadPage();
  }

  return (
    <div style={CONTAINER_STYLE}>
      <FormControl>
        <InputLabel htmlFor="organization-dev-tool">Organization</InputLabel>
        <Select
          value={props.user.organization}
          disabled={organizations === 'loading'}
          onChange={(event) => onChangeOrganization(event.target.value as string)}
          inputProps={INPUT_PROPS}
          label="Organization"
        >
          {menuItems}
        </Select>
      </FormControl>
    </div>
  );
};
